import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Presentation } from '../models/presentation';

@Injectable({
  providedIn: 'root'
})
export class PresentationsService {

  constructor(private http:HttpClient) { }

  async getPresentations() : Promise<Presentation[]> {
    return this.http.get<Presentation[]>('/api/presentation')
      .toPromise();
  }
}
